export default {"src":"/_next/static/media/ShelfLifeIconRed.f22e07f8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};